import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/painelOperador.css';
import '../styles/gestaoBpoRh.css';
import '../styles/fiscal.css';
import '../styles/fiscalModerno.css';

// Fiscal → Configurações: (1) a conta central — operador cuja conta Google (conectada em
// Fiscal → Usuários) grava as entregas na agenda compartilhada Prazos Fiscais e envia os
// e-mails do Fiscal como fiscal@ (alias "Enviar como" do Gmail); (2) o cadastro de contador
// de cada usuário, usado para assinar a Declaração de Faturamento.

const API = process.env.REACT_APP_API_BASE;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });
const CONTADOR_VAZIO = { nome: '', cpf: '', crc: '', crc_uf: '' };

const mascaraCpf = (v) => {
  const d = (v || '').replace(/\D/g, '').slice(0, 11);
  return d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
};

export default function FiscalConfiguracoes() {
  const [central, setCentral] = useState(null);
  const [form, setForm] = useState({ operador_id: '', calendario_id: '', remetente_como: '' });
  const [contador, setContador] = useState(CONTADOR_VAZIO);
  const [temCadastro, setTemCadastro] = useState(false);
  const [contadores, setContadores] = useState([]);
  const [erro, setErro] = useState('');
  const [msg, setMsg] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [salvandoCentral, setSalvandoCentral] = useState(false);

  const aplicarCentral = useCallback((d) => {
    setCentral(d);
    setForm({ operador_id: d.remetente?.operador_id || '', calendario_id: d.agenda?.calendario_id || '', remetente_como: d.remetente?.esperado || '' });
  }, []);
  const carregarCentral = useCallback(() => {
    axios.get(`${API}/api/fiscal/remetente/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => aplicarCentral(r.data))
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível ler a conta central'));
  }, [aplicarCentral]);
  const carregarContadores = useCallback(() => {
    axios.get(`${API}/api/fiscal/contadores/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => setContadores(r.data.contadores || []))
      .catch(() => {});
  }, []);
  useEffect(() => {
    carregarCentral();
    carregarContadores();
    axios.get(`${API}/api/fiscal/contador/meu/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => {
        const c = r.data.contador;
        setTemCadastro(!!c);
        if (c) setContador({ ...c, cpf: mascaraCpf(c.cpf) });
      })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível ler seu cadastro de contador'));
  }, [carregarCentral, carregarContadores]);

  const salvarCentral = () => {
    setSalvandoCentral(true); setErro('');
    axios.post(`${API}/api/fiscal/remetente/`, form, { headers: headers() })
      .then((r) => { aplicarCentral(r.data); setMsg(r.data.mensagem); })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível salvar'))
      .finally(() => setSalvandoCentral(false));
  };

  const salvarContador = () => {
    setSalvando(true); setErro('');
    axios.put(`${API}/api/fiscal/contador/meu/`, { ...contador, cpf: contador.cpf.replace(/\D/g, '') }, { headers: headers() })
      .then((r) => { setMsg(r.data.mensagem); setTemCadastro(true); carregarContadores(); })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível salvar'))
      .finally(() => setSalvando(false));
  };

  const agenda = central?.agenda;
  const conectado = !!agenda?.conectado;

  return (
    <div className="painel-op fz-app">
      <div className="container-fluid mt-4 shadow p-4 rounded bg-white">
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center">
            <i className="fas fa-sliders header-icon me-2" aria-hidden="true"></i>
            <h2 className="titulo-pagina m-0">Configurações Fiscais</h2>
          </div>
        </div>

        {erro && <div className="alert alert-danger py-2" role="button" onClick={() => setErro('')}><i className="fas fa-circle-exclamation me-2"></i>{erro}</div>}
        {msg && <div className="alert alert-success py-2" role="button" onClick={() => setMsg('')}><i className="fas fa-circle-check me-2"></i>{msg}</div>}

        <div className="row g-3">
          <div className="col-lg-6">
            <section className="po-card">
              <header className="po-card-head"><h3><i className="fas fa-calendar-check" aria-hidden="true"></i>Agenda das entregas e e-mails</h3></header>
              <div className="po-card-body pad">
                <p className="mb-3">O "Gerar mês", o status das entregas e o relatório diário gravam na agenda compartilhada <b>Prazos Fiscais</b> e os e-mails do Fiscal saem <b>como {form.remetente_como || 'fiscal@'}</b> — sempre pela conta Google escolhida abaixo, não importa quem clica.</p>
                {central === null ? (
                  <div className="text-muted"><i className="fas fa-spinner fa-spin me-2"></i>Verificando...</div>
                ) : (
                  <div className="mb-3">
                    {conectado
                      ? <span className="fz-selo ok"><i className="fas fa-circle-check"></i>{agenda.operador_nome} conectado ({agenda.conta})</span>
                      : <span className="fz-selo alerta"><i className="fas fa-triangle-exclamation"></i>{agenda?.mensagem}</span>}
                    {conectado && central.remetente?.autenticado_em && <div className="fz-sub mt-2">Conta conectada em {central.remetente.autenticado_em}</div>}
                  </div>
                )}
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label small fw-bold mb-1">Conta que grava e envia</label>
                    <select className="form-select" value={form.operador_id} onChange={(e) => setForm((f) => ({ ...f, operador_id: e.target.value }))}>
                      <option value="">— escolha o operador —</option>
                      {(central?.operadores || []).map((o) => (
                        <option key={o.id} value={o.id}>{o.nome}{o.conta ? ` (${o.conta})` : ' — sem conta Google conectada'}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-bold mb-1">ID da agenda Prazos Fiscais</label>
                    <input className="form-control fz-mono small" value={form.calendario_id} onChange={(e) => setForm((f) => ({ ...f, calendario_id: e.target.value }))} />
                  </div>
                  <div className="col-12">
                    <label className="form-label small fw-bold mb-1">Enviar e-mails como</label>
                    <input className="form-control" value={form.remetente_como} onChange={(e) => setForm((f) => ({ ...f, remetente_como: e.target.value }))} />
                  </div>
                </div>
                <button className="btn btn-primary mt-3" onClick={salvarCentral} disabled={salvandoCentral || !form.operador_id}>
                  <i className={`fas ${salvandoCentral ? 'fa-spinner fa-spin' : 'fa-floppy-disk'} me-2`}></i>Salvar
                </button>
                <div className="form-text mt-3">
                  A conta é conectada em <b>Fiscal → Usuários</b> ("Conectar conta Google"). Ela precisa ter permissão de edição na agenda e o endereço {form.remetente_como || 'fiscal@'} em "Enviar como" no Gmail — sem isso, o Google troca o remetente pelo e-mail da própria conta.
                </div>
              </div>
            </section>
          </div>

          <div className="col-lg-6">
            <section className="po-card">
              <header className="po-card-head"><h3><i className="fas fa-user-tie" aria-hidden="true"></i>Meu cadastro de contador</h3></header>
              <div className="po-card-body pad">
                <p className="fz-sub mb-3">Usado para assinar a Declaração de Faturamento. Só você altera o seu; os outros veem o CPF mascarado.</p>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label small fw-bold mb-1">Nome completo</label>
                    <input className="form-control" value={contador.nome} onChange={(e) => setContador((c) => ({ ...c, nome: e.target.value }))} />
                  </div>
                  <div className="col-md-5">
                    <label className="form-label small fw-bold mb-1">CPF</label>
                    <input className="form-control fz-mono" inputMode="numeric" value={contador.cpf} onChange={(e) => setContador((c) => ({ ...c, cpf: mascaraCpf(e.target.value) }))} />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label small fw-bold mb-1">CRC</label>
                    <input className="form-control" placeholder="RS-012345/O-6" value={contador.crc} onChange={(e) => setContador((c) => ({ ...c, crc: e.target.value }))} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label small fw-bold mb-1">UF do CRC</label>
                    <input className="form-control" maxLength={2} value={contador.crc_uf} onChange={(e) => setContador((c) => ({ ...c, crc_uf: e.target.value.toUpperCase() }))} />
                  </div>
                </div>
                <button className="btn btn-primary mt-3" onClick={salvarContador} disabled={salvando || !contador.nome.trim()}>
                  <i className={`fas ${salvando ? 'fa-spinner fa-spin' : 'fa-floppy-disk'} me-2`}></i>{temCadastro ? 'Atualizar cadastro' : 'Salvar cadastro'}
                </button>
              </div>
            </section>
          </div>

          <div className="col-12">
            <section className="po-card">
              <header className="po-card-head">
                <h3><i className="fas fa-users" aria-hidden="true"></i>Contadores cadastrados</h3>
                <span className="badge bg-light text-dark">{contadores.length}</span>
              </header>
              <div className="po-card-body">
                <table className="table po-table align-middle mb-0">
                  <thead><tr><th>Nome</th><th>CPF</th><th>CRC</th><th>Login</th></tr></thead>
                  <tbody>
                    {contadores.map((c) => (
                      <tr key={c.user_id}><td className="fw-semibold">{c.nome}</td><td className="fz-mono">{c.cpf}</td><td>{c.crc} / {c.crc_uf}</td><td className="small">{c.login || '—'}</td></tr>
                    ))}
                    {contadores.length === 0 && <tr><td colSpan={4} className="text-center text-muted py-4">Nenhum contador cadastrado ainda.</td></tr>}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
